import { lazy } from 'react';
import RouteTypes from '../route_types';
import { LEVEL_TWO_ADMIN_ROUTES } from '../path';
import { PATH } from '../../../utils/Constants';
// Common Components
const CommonLayout = lazy(() => import('../../../voim/component/common/Layout'));
const NotFound = lazy(() => import('../../../voim/component/common/NotFound'));
const ChangePassword = lazy(() => import('../../../voim/component/common/ChangePassword'));
// Level Two Components
// Dashboard
const Dashboard = lazy(() => import('../../../voim/component/admin/level-two-admin/dashboard'));
// Level 3
const ThirdLevelList = lazy(
    () => import('../../../voim/component/admin/level-two-admin/level-three/ThirdLevelList')
);
const AddThirdLevel = lazy(
    () => import('../../../voim/component/admin/level-two-admin/level-three/AddThirdLevel')
);
const ViewLevelThree = lazy(
    () => import('../../../voim/component/admin/level-two-admin/level-three/ViewLevelThree')
);
// Educator
const EducatorList = lazy(
    () => import('../../../voim/component/admin/level-two-admin/educator/EducatorList')
);
const AddEducator = lazy(
    () => import('../../../voim/component/admin/level-two-admin/educator/AddEducator')
);
const ViewEducator = lazy(
    () => import('../../../voim/component/admin/level-two-admin/educator/EducatorView')
);
const EducatorBatchUpload = lazy(
    () => import('../../../voim/component/admin/level-two-admin/educator/EducatorBatchUpload')
);
// Student
const StudentList = lazy(
    () => import('../../../voim/component/admin/level-two-admin/student/StudentList')
);
// Subject
const SubjectList = lazy(
    () => import('../../../voim/component/admin/level-two-admin/subject/SubjectList')
);
const AddSubject = lazy(
    () => import('../../../voim/component/admin/level-two-admin/subject/AddSubject')
);
const ViewSubject = lazy(
    () => import('../../../voim/component/admin/level-two-admin/subject/ViewSubject')
);
// Sub Category
const SubCategoryList = lazy(
    () => import('../../../voim/component/admin/level-two-admin/sub-category/SubCategoryList')
);
const AddSubCategory = lazy(
    () => import('../../../voim/component/admin/level-two-admin/sub-category/AddSubCategory')
);
const ViewSubCategory = lazy(
    () => import('../../../voim/component/admin/level-two-admin/sub-category/ViewSubCategory')
);
// Session
const SessionList = lazy(
    () => import('../../../voim/component/admin/level-two-admin/session/SessionList')
);
const SessionSummary = lazy(
    () => import('../../../voim/component/admin/level-two-admin/session/SessionSummary')
);

const createSession = lazy(
    () => import('../../../voim/component/admin/level-two-admin/session/createSession')
);

// Financial Report
const FinancialReport = lazy(
    () => import('./../../../voim/component/common/Reports/FinancialReport')
);
const CustomFinancialReport = lazy(
    () => import('./../../../voim/component/common/Reports/CustomFinancialReport')
);
const PayoutReport = lazy(() => import('./../../../voim/component/common/Reports/PayoutReport'));
const LevelWiseReport = lazy(() => import('./../../../voim/component/common/LevelWiseReport'));
// Broadcast Video Call
const ImActiveVisit = lazy(() => import('./../../../voim/component/tutor/video'));

export default [
    // Dashboard
    {
        path: LEVEL_TWO_ADMIN_ROUTES.DASHBOARD,
        component: CommonLayout,
        pageComponent: Dashboard,
        roleType: RouteTypes.LEVEL_TWO_ADMIN,
        title: 'Dashboard',
        showNavigation: true,
        navMenu: true,
        active: 'dashboard',
        levelTitle: 'Level 2',
        icon: 'material-icons',
    },
    {
        path: LEVEL_TWO_ADMIN_ROUTES.LEVEL_WISE_REPORT,
        component: CommonLayout,
        pageComponent: LevelWiseReport,
        roleType: RouteTypes.LEVEL_TWO_ADMIN,
        title: 'Dashboard',
        showNavigation: true,
        navMenu: false,
        active: 'dashboard',
        levelTitle: 'Level 2',
    },
    // Level 3
    {
        path: LEVEL_TWO_ADMIN_ROUTES.LEVEL_THREE,
        component: CommonLayout,
        pageComponent: ThirdLevelList,
        roleType: RouteTypes.LEVEL_TWO_ADMIN,
        title: 'Level 3',
        showNavigation: true,
        navMenu: true,
        active: 'level-three',
        levelTitle: 'Level 2',
        icon: 'fa fa-university',
    },
    {
        path: LEVEL_TWO_ADMIN_ROUTES.ADD_LEVEL,
        component: CommonLayout,
        pageComponent: AddThirdLevel,
        roleType: RouteTypes.LEVEL_TWO_ADMIN,
        title: 'Add Level 3',
        showNavigation: true,
        navMenu: false,
        active: 'level-three',
        levelTitle: 'Level 2',
    },
    {
        path: LEVEL_TWO_ADMIN_ROUTES.EDIT_LEVEL,
        component: CommonLayout,
        pageComponent: AddThirdLevel,
        roleType: RouteTypes.LEVEL_TWO_ADMIN,
        title: 'Edit Level 3',
        showNavigation: true,
        navMenu: false,
        active: 'level-three',
        levelTitle: 'Level 2',
    },
    {
        path: LEVEL_TWO_ADMIN_ROUTES.VIEW_LEVEL,
        component: CommonLayout,
        pageComponent: ViewLevelThree,
        roleType: RouteTypes.LEVEL_TWO_ADMIN,
        title: 'View Level 3',
        showNavigation: true,
        navMenu: false,
        active: 'level-three',
        levelTitle: 'Level 2',
    },
    // Subjects
    {
        path: LEVEL_TWO_ADMIN_ROUTES.SUBJECTLIST,
        component: CommonLayout,
        pageComponent: SubjectList,
        roleType: RouteTypes.LEVEL_TWO_ADMIN,
        title: 'Subjects',
        showNavigation: true,
        navMenu: true,
        active: 'subjects',
        levelTitle: 'Level 2',
        icon: 'fa fa-file',
    },
    {
        path: LEVEL_TWO_ADMIN_ROUTES.ADD_SUBJECT,
        component: CommonLayout,
        pageComponent: AddSubject,
        roleType: RouteTypes.LEVEL_TWO_ADMIN,
        title: 'Add Subject',
        showNavigation: true,
        navMenu: false,
        active: 'subjects',
        levelTitle: 'Level 2',
    },
    {
        path: LEVEL_TWO_ADMIN_ROUTES.EDIT_SUBJECT,
        component: CommonLayout,
        pageComponent: AddSubject,
        roleType: RouteTypes.LEVEL_TWO_ADMIN,
        title: 'Edit Subject',
        showNavigation: true,
        navMenu: false,
        active: 'subjects',
        levelTitle: 'Level 2',
    },
    {
        path: LEVEL_TWO_ADMIN_ROUTES.SUBJECT,
        component: CommonLayout,
        pageComponent: ViewSubject,
        roleType: RouteTypes.LEVEL_TWO_ADMIN,
        title: 'View Subject',
        showNavigation: true,
        navMenu: false,
        active: 'subjects',
        levelTitle: 'Level 2',
    },
    // SubCategory
    {
        path: LEVEL_TWO_ADMIN_ROUTES.SUB_CATEGORY_LIST,
        component: CommonLayout,
        pageComponent: SubCategoryList,
        roleType: RouteTypes.LEVEL_TWO_ADMIN,
        title: 'Sub Categories',
        showNavigation: true,
        navMenu: true,
        active: 'sub-categories',
        levelTitle: 'Level 2',
        icon: 'fa fa-file-text',
    },
    {
        path: LEVEL_TWO_ADMIN_ROUTES.ADD_SUBCATEGORY,
        component: CommonLayout,
        pageComponent: AddSubCategory,
        roleType: RouteTypes.LEVEL_TWO_ADMIN,
        title: 'Add Subcategory',
        showNavigation: true,
        navMenu: false,
        active: 'sub-categories',
        levelTitle: 'Level 2',
    },
    {
        path: LEVEL_TWO_ADMIN_ROUTES.EDIT_SUBCATEGORY,
        component: CommonLayout,
        pageComponent: AddSubCategory,
        roleType: RouteTypes.LEVEL_TWO_ADMIN,
        title: 'Edit Subcategory',
        showNavigation: true,
        navMenu: false,
        active: 'sub-categories',
        levelTitle: 'Level 2',
    },
    {
        path: LEVEL_TWO_ADMIN_ROUTES.SUBCATEGORY,
        component: CommonLayout,
        pageComponent: ViewSubCategory,
        roleType: RouteTypes.LEVEL_TWO_ADMIN,
        title: 'View Sub Category',
        showNavigation: true,
        navMenu: false,
        active: 'sub-categories',
        levelTitle: 'Level 2',
    },
    // Educator
    {
        path: LEVEL_TWO_ADMIN_ROUTES.EDUCATORS,
        component: CommonLayout,
        pageComponent: EducatorList,
        roleType: RouteTypes.LEVEL_TWO_ADMIN,
        title: 'Educators',
        showNavigation: true,
        navMenu: true,
        active: 'educators',
        levelTitle: 'Level 2',
        icon: 'fas fa-user-circle',
    },
    {
        path: LEVEL_TWO_ADMIN_ROUTES.VIEW_EDUCATOR,
        component: CommonLayout,
        pageComponent: ViewEducator,
        roleType: RouteTypes.LEVEL_TWO_ADMIN,
        title: 'View Educator',
        showNavigation: true,
        navMenu: false,
        active: 'educators',
        levelTitle: 'Level 2',
    },
    {
        path: LEVEL_TWO_ADMIN_ROUTES.EDIT_EDUCATOR,
        component: CommonLayout,
        pageComponent: AddEducator,
        roleType: RouteTypes.LEVEL_TWO_ADMIN,
        title: 'Edit Educator',
        showNavigation: true,
        navMenu: false,
        active: 'educators',
        levelTitle: 'Level 2',
    },
    {
        path: LEVEL_TWO_ADMIN_ROUTES.ADD_EDUCATOR,
        component: CommonLayout,
        pageComponent: AddEducator,
        roleType: RouteTypes.LEVEL_TWO_ADMIN,
        title: 'Add Educator',
        showNavigation: true,
        navMenu: false,
        active: 'educators',
        levelTitle: 'Level 2',
    },
    {
        path: LEVEL_TWO_ADMIN_ROUTES.EDUCATOR_BATCH,
        component: CommonLayout,
        pageComponent: EducatorBatchUpload,
        roleType: RouteTypes.LEVEL_TWO_ADMIN,
        title: 'Upload Educators',
        showNavigation: true,
        navMenu: false,
        active: 'educators',
        levelTitle: 'Level 2',
    },
    // Student
    {
        path: LEVEL_TWO_ADMIN_ROUTES.STUDENTS,
        component: CommonLayout,
        pageComponent: StudentList,
        roleType: RouteTypes.LEVEL_TWO_ADMIN,
        title: 'Students',
        showNavigation: true,
        navMenu: true,
        active: 'students',
        levelTitle: 'Level 2',
        icon: 'fas fa-user-graduate',
    },
    {
        path: LEVEL_TWO_ADMIN_ROUTES.SESSIONS_LIST,
        component: CommonLayout,
        pageComponent: SessionList,
        roleType: RouteTypes.LEVEL_TWO_ADMIN,
        title: 'Sessions',
        showNavigation: true,
        navMenu: true,
        active: 'sessions',
        levelTitle: 'Level 2',
        icon: 'fa fa-calendar',
    },
    {
        path: LEVEL_TWO_ADMIN_ROUTES.SESSION_SUMMARY,
        component: CommonLayout,
        pageComponent: SessionSummary,
        roleType: RouteTypes.LEVEL_TWO_ADMIN,
        title: 'Session Summary',
        showNavigation: true,
        navMenu: false,
        active: 'sessions',
        levelTitle: 'Level 2',
    },

    {
        path: LEVEL_TWO_ADMIN_ROUTES.CREATE_SESSION,
        component: CommonLayout,
        pageComponent: createSession,
        roleType: RouteTypes.LEVEL_TWO_ADMIN,
        title: 'Create Session',
        showNavigation: true,
        navMenu: false,
        active: 'sessions',
        levelTitle: 'Level 2',
    },

    // Financial Report
    {
        path: LEVEL_TWO_ADMIN_ROUTES.FINANCIAL_REPORT,
        component: CommonLayout,
        pageComponent: FinancialReport,
        roleType: RouteTypes.LEVEL_TWO_ADMIN,
        title: 'Financial Reports',
        showNavigation: true,
        navMenu: true,
        active: 'financial-reports',
        levelTitle: 'Level 2',
        icon: 'fa-solid fa-money-bill-wave',
    },
    {
        path: LEVEL_TWO_ADMIN_ROUTES.CUSTOM_FINANCIAL_REPORT,
        component: CommonLayout,
        pageComponent: CustomFinancialReport,
        roleType: RouteTypes.LEVEL_TWO_ADMIN,
        title: 'Financial Reports',
        showNavigation: true,
        navMenu: false,
        active: 'financial-reports',
        levelTitle: 'Level 2',
    },
    {
        path: LEVEL_TWO_ADMIN_ROUTES.PAYOUT_REPORT,
        component: CommonLayout,
        pageComponent: PayoutReport,
        roleType: RouteTypes.LEVEL_TWO_ADMIN,
        title: 'Financial Reports',
        showNavigation: true,
        navMenu: false,
        active: 'financial-reports',
        levelTitle: 'Level 2',
    },
    {
        path: `${PATH.LEVEL_TWO_ADMIN.VIDEO_CALL}/:visitId/:userType/:userId/broadcast`,
        component: ImActiveVisit,
        roleType: RouteTypes.LEVEL_TWO_ADMIN,
    },
    // Common
    {
        path: LEVEL_TWO_ADMIN_ROUTES.CHANGE_PASSWORD,
        component: CommonLayout,
        pageComponent: ChangePassword,
        roleType: RouteTypes.LEVEL_TWO_ADMIN,
        title: 'Change Password',
        showNavigation: false,
        navMenu: false,
        active: 'Change Password',
        levelTitle: 'Level 2',
    },
    {
        path: '*',
        component: NotFound,
        roleType: RouteTypes.LEVEL_TWO_ADMIN,
        title: 'Not Found',
        showNavigationive: false,
        navMenu: false,
        active: 'Not Found',
        levelTitle: 'Level 2',
    },
];
